/*
 * Customs User Role History Service
 * !== 세관 사용자 권한 이력 서비스 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { comnUtils } from "@/comn/utils";
import { api } from "@/comn";
import { TFormSchema, TGridSchema } from "@/comn/hooks";

export const BASE = {
    path: `${ptlEnvs.base}/ptl/role-hist`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/ptl/role-hist`,
    subApi: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/ptl/cstm-auth/mgmt`, //check this

    nodes: [],
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    getCstmUsrDta: (data: any) => api.get(`${BASE.api}/usr`, { params: comnUtils.toGetParams(data) }),
    getUsrRoleHistList: (data: any, page: number, size: number) =>
        api.get(`${BASE.api}/list?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) }),

    getUsrRoleHistExcelList: (data: any) => api.get(`${BASE.api}/excel`, { params: comnUtils.toGetParams(data) }),

    getCstmUsrList: (data: any, page: number, size: number) =>
        api.get(`${BASE.subApi}/cstm-usr?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) }),
    getComboList: (data: any) => api.get(`${BASE.subApi}/combo`, { params: comnUtils.toGetParams(data) }),
    // Get a excel list of Customs staff.
    getCstmUsrExcelList: (data: any) =>
        api.get(`${BASE.subApi}/cstm-usr/excel`, { params: comnUtils.toGetParams(data) }),
};

export const URLS = {
    ptli1003007q: `${BASE.path}/ptli1003007q`, // Custom Office User Role Management
    ptli1003008q: `${BASE.path}/ptli1003008q`, // Save. Custom Office User Role Data
};

export const SF_USR_ROLE_HIST_SRCH: TFormSchema = {
    id: "form_cstmRoleSrch",
    schema: {
        usrDmnId: { type: "text", label: "L_USR_DMN_ID" },
        cstmOfcrNo: { type: "text", label: "L_CSTM_OFCR_NO" },
        cstmCd: { type: "code", label: "L_CSTM_OFCE", area: "cstmCd", popupSize: "md" },
        cstmOfcrNm: { type: "text", label: "L_CSTM_OFCR_NM" },
    },
};

export const SF_COMBO_SRCH: TFormSchema = {
    id: "form_comboSrch",
    schema: { cstmOrgzTpCd: { type: "text" }, cstmOrgzCd: { type: "text" }, uprCstmOrgzId: { type: "text" } },
};

export const SF_CSTM_OFCR_INFO: TFormSchema = {
    id: "form_cstmOfcrInfo",
    schema: {
        sctnNm: { type: "text", label: "L_SCTN", labelSize: 2, controlSize: 2, edit: false },
        cstmNm: { type: "text", label: "L_CSTM_OFCE", labelSize: 2, controlSize: 2, edit: false },
        unitNm: { type: "text", label: "L_UT", labelSize: 2, controlSize: 2, edit: false },
        usrDmnId: { type: "text", label: "L_USR_DMN_ID", labelSize: 2, controlSize: 2, edit: false },
        cstmOfcrNo: { type: "text", label: "L_CSTM_OFCR_NO", labelSize: 2, controlSize: 2, edit: false },
        usrNm: { type: "text", label: "L_CSTM_OFCR_NM", labelSize: 2, controlSize: 2, edit: false },
        usrTelno: { type: "text", label: "L_TELNO", edit: false },
        usrEmlAddr: { type: "text", label: "L_EML_ADDR", edit: false },
    },
};

export const SG_CSTM_USR_LIST: TGridSchema = {
    id: "grid_cstmUsrList",
    options: { index: true, pagination: "out" },
    head: [
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "0.8*" }] },
        { cells: [{ header: "L_USR_DMN_ID", binding: "usrDmnId", width: "0.8*" }] },
        { cells: [{ header: "L_CSTM_OFCR_NO", binding: "cstmOfcrNo", width: "0.8*" }] },
        { cells: [{ header: "L_SCTN", binding: "sctnNm", width: "1.5*" }] },
        { cells: [{ header: "L_CSTM", binding: "cstmNm", width: "1.5*" }] },
        { cells: [{ header: "L_UT_CD", binding: "unitNm", width: "1.5*" }] },
    ],
    body: [
        // { cells: [{ binding: "sctnNm", align: "left" }] },
        { cells: [{ binding: "usrNm", align: "left" }] },
        // { cells: [{ binding: "cstmNm", align: "left" }] },
        { cells: [{ binding: "usrDmnId", align: "left" }] },
        { cells: [{ binding: "cstmOfcrNo" }] },
        { cells: [{ binding: "unitNm", align: "left" }] },
        // { cells: [{ binding: "usrDmnId", align: "left" }] },
        { cells: [{ binding: "cstmNm", align: "left" }] },
        { cells: [{ binding: "unitNm", align: "left" }] },
    ],
};

export const SG_USR_ROLE_HIST_LIST: TGridSchema = {
    id: "grid_usrRoleHistList",
    options: { pagination: "out" },
    head: [
        { cells: [{ header: "L_ROLE_ID", binding: "roleId", width: "0.5*" }] },
        { cells: [{ header: "L_ROLE_NM", binding: "roleNm", width: "0.5*" }] },
        { cells: [{ header: "L_ROLE_DESC", binding: "roleDesc", width: "0.8*" }] },
        { cells: [{ header: "L_DEL_YN", binding: "delYn", width: "0.2*" }] },
        { cells: [{ header: "L_USER_DMN_ID", binding: "lastMdfrId", width: "0.5*" }] },
        { cells: [{ header: "L_LAST_MDFY_DT", binding: "lastMdfyDtm", width: "0.5*" }] },
        { cells: [{ header: "Attached Memo", binding: "attchFle", width: "0.5*" }] },
    ],
    body: [
        { cells: [{ binding: "roleId", align: "center" }] },
        { cells: [{ binding: "roleNm", align: "left" }] },
        { cells: [{ binding: "roleDesc", align: "left" }] },
        { cells: [{ binding: "delYn", align: "center" }] },
        { cells: [{ binding: "lastMdfrId", align: "center" }] },
        { cells: [{ binding: "lastMdfyDtm", align: "center" }] },
        { cells: [{ binding: "attchFle", align: "center" }] },
    ],
};
export const SG_USR_ROLE_HIST_EXCEL_LIST: TGridSchema = {
    id: "grid_usrRoleHistExcelList",
    options: { pagination: "out" },
    head: [
        { cells: [{ header: "L_ROLE_ID", binding: "roleId", width: "0.5*" }] },
        { cells: [{ header: "L_ROLE_NM", binding: "roleNm", width: "0.5*" }] },
        { cells: [{ header: "L_ROLE_DESC", binding: "roleDesc", width: "0.8*" }] },
        { cells: [{ header: "L_DEL_YN", binding: "delYn", width: "0.2*" }] },
        { cells: [{ header: "L_USER_DMN_ID", binding: "lastMdfrId", width: "0.5*" }] },
        { cells: [{ header: "L_LAST_MDFY_DT", binding: "lastMdfyDtm", width: "0.5*" }] },
    ],
    body: [
        { cells: [{ binding: "roleId", align: "center" }] },
        { cells: [{ binding: "roleNm", align: "left" }] },
        { cells: [{ binding: "roleDesc", align: "left" }] },
        { cells: [{ binding: "delYn", align: "center" }] },
        { cells: [{ binding: "lastMdfrId", align: "center" }] },
        { cells: [{ binding: "lastMdfyDtm", align: "center" }] },
    ],
};

export const SG_CSTM_USR_EXCEL_LIST: TGridSchema = {
    id: "grid_cstmUsrExcelList",
    options: { index: true, pagination: "out" },
    head: [
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "0.8*" }] },
        { cells: [{ header: "L_USR_DMN_ID", binding: "usrDmnId", width: "0.8*" }] },
        { cells: [{ header: "L_CSTM_OFCR_NO", binding: "cstmOfcrNo", width: "0.8*" }] },
        { cells: [{ header: "L_SCTN", binding: "sctnNm", width: "1.5*" }] },
        { cells: [{ header: "L_CSTM", binding: "cstmNm", width: "1.5*" }] },
        { cells: [{ header: "L_UT_CD", binding: "unitNm", width: "1.5*" }] },
    ],
    body: [
        { cells: [{ binding: "sctnNm", align: "left" }] },
        { cells: [{ binding: "cstmNm", align: "left" }] },
        { cells: [{ binding: "cstmOfcrNo" }] },
        { cells: [{ binding: "unitNm", align: "left" }] },
        { cells: [{ binding: "usrDmnId", align: "left" }] },
        { cells: [{ binding: "usrNm", align: "left" }] },
    ],
};
